import React from 'react';

const LostPasswordSend = () => {
    let T = window.Texts.login;
    return (
        <div className="lost-password-page">
            <div className="cover">
                <div className="headline">
                    <h1>{T.lostPasswordSendTitle}</h1>
                </div>
                <div className="inner-500">
                    <p /><p>{T.dearCustomer},</p>
                    <p>{T.lostPasswordSendText}</p><p />
                </div>
            </div>
        </div>
    );
};

export default LostPasswordSend;